import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useUSPsSection} from '../useGetProductBulkSection';
import {USPsLoading} from './USPsLoading';
import {USPsView, USPsViewProps} from './USPsView';

export const USPs: React.FC<USPsViewProps> = props => {
  return (
    <DataFetcher
      request={useUSPsSection()}
      Error={null}
      Loading={() => <USPsLoading className={props.className} />}
      View={USPsView}
      viewProps={props}
    />
  );
};
